import { Link, useLocation } from '@tanstack/react-router'
import { LogoMark, LogoWordmark } from './Logo'
import styles from './TopNav.module.css'

export function TopNav() {
  const { pathname } = useLocation()
  const isHome = pathname === '/'

  return (
    <nav className={styles.nav}>
      <Link to="/" className={styles.logo} aria-label="Fantyx.Pro">
        <LogoMark size={22} />
        <LogoWordmark />
      </Link>

      {isHome && (
        <>
          <div className={styles.links}>
            <a href="#esportes" className={styles.link}>Esportes</a>
            <a href="#como-funciona" className={styles.link}>Como funciona</a>
            <a href="#formatos" className={styles.link}>Formatos</a>
            <a href="#planos" className={styles.link}>Planos</a>
            <a href="#faq" className={styles.link}>FAQ</a>
          </div>
          <div className={styles.actions}>
            <Link to="/entrar" search={{ redirect: undefined, code: undefined, error: undefined }} className={styles.btnPrimary}>Entrar</Link>
          </div>
        </>
      )}
    </nav>
  )
}
